(function($){
    var banner = $('#banner');
    
    if( banner ) {
        $('#siteHeader').css('padding-top',0);

        $('.banner__close-icon').on('click', function() {
            banner.animate({height: "0px", padding: 0}, 100);
        })
    }
})(jQuery);
